import React, { useState, useEffect } from "react";
import { Box, Button, CircularProgress, IconButton, TextField, Typography } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import { MenuCartItem } from "../models/fullMenuCart";
import { useTemporaryMenuCartProviderCart } from "../hooks/contexts/TemporaryMenuCartContext";

type RemoveButtonProps = {
    menuCartItem: MenuCartItem;
    onSuccess: () => Promise<void>
    onError: (error: Error) => Promise<void>
};

export const RemoveFromCartButton: React.FC<RemoveButtonProps> = ({ menuCartItem, onSuccess, onError }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { removeItemFromTemporaryCart } = useTemporaryMenuCartProviderCart()

    if (isLoading) {
        return <CircularProgress size={24} sx={{ color: "black" }} />
    }

    const handleRemove = async () => {
        try {
            setIsLoading(true)
            await removeItemFromTemporaryCart(menuCartItem)
            await onSuccess()
        } catch (error) {
            await onError(error as Error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <IconButton
                sx={{ color: "#162C1F" }}
                onClick={handleRemove}
                disabled={isLoading}
            >
                <RemoveIcon />
            </IconButton>
        </Box>
    );
};
